module.exports = __webpack_public_path__ + "static/media/quarrytruck3.0aad7dac.jpg";